<template>
  <div class="SpecialScreeningsSlider">
    <div class="sdHome">
      <div
        v-if="
          routeName === '/' ||
            routeName === '/nowShowingList' ||
            routeName === '/miniFestivalList'
        "
        class="col-12 sliderDetails px-0 pr-md-3 px-lg-3"
      >
        <p class="movieCat">
          SPECIAL SCREENINGS
          <span class="txt-link">
            <router-link class="ml-3 ml-lg-4 mr-2" to
              >Watch Movies on Demand</router-link
            >
            <!-- <img
              id="tooltip-2"
              src="@/assets/img/svg/info-rd-icon.svg"
              class="rounded-circle"
            /> -->
            <!-- <button class="btn btn-danger viewmore-btn mr-4" @click="showModal = true">Know more</button> -->
          </span>
          <b-modal v-model="showModal" ok-variant="danger" >
            <ul>
              <li>
                Select the favorite movie you want to watch by clicking on the
                movie image.
              </li>
              <li>
                These movies are special screening created exclusively for fans
                like you to enjoy.
              </li>
              <li>Join the screening by completing the booking process.</li>
              <li>Enjoy Exclusive screening of your favorite movie.</li>
            </ul>
    </b-modal>
          <!-- ToolTip -->
          <b-tooltip target="tooltip-2" placement="right">
            
          </b-tooltip>
        </p>
        <p class="link">
          <router-link :to="{ name: 'specialScreeningList' }"
            >(See All)</router-link
          >
        </p>
      </div>
    </div>

    <div class="sd">
      <div
        v-if="
          routeName !== '/' &&
            routeName !== '/nowShowingList' &&
            routeName !== '/miniFestivalList'
        "
        class="col-12 sliderDetails px-0 px-md-3"
      >
        <p class="movieCat">
          SPECIAL SCREENINGS
          <span class="link ml-2">
            <router-link :to="{ name: 'specialScreeningList' }"
              >(See All)</router-link
            >
          </span>
        </p>
      </div>
    </div>

    <Slick ref="slick2" :options="movieSlider">
      <div
        v-if="SpecialScreening.length == 0"
        v-for="(singleMovie, singleindex) in 10"
        :key="singleindex"
      >
        <div class="movieSlider-container mx-auto text-center">
          <div class="img-container">
            <img
              src="@/assets/img/transparent_movie.png"
              alt
              class="img-fluid mx-auto banner"
            />
          </div>
        </div>
      </div>

      <div
        v-if="SpecialScreening.length > 0"
        v-for="(singleMovie, singleMovieIndex) in SpecialScreening"
        :key="singleMovieIndex"
      >
        <router-link
          :to="{
            name: 'createScreen',
            params: { movieId: singleMovie.ID, categoryId: 2 }
          }"
        >
          <div class="movieSlider-container mx-auto text-center">
            <div class="img-container">
              <router-link
                :to="{
                  name: 'createScreen',
                  params: { movieId: singleMovie.ID, categoryId: 2 }
                }"
              >
                <img
                  :src="singleMovie.Image"
                  alt
                  class="img-fluid mx-auto banner"
                />
              </router-link>

              <!-- <div class="img-text py-2">
                    <p class="mb-0"><span>{{singleMovie.ScheduleCount}}</span> Screenings</p>
              </div>-->
            </div>
            <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
              <p class="mb-0 title">{{ singleMovie.Name }}</p>
              <ul class="list-inline mb-0 mInfo">
                <li class="list-inline-item">{{ singleMovie.Year }}</li>
                <li class="list-inline-item">|</li>
                <li class="list-inline-item">{{ singleMovie.Rated }}</li>
              </ul>
            </div>
          </div>
        </router-link>
      </div>
    </Slick>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import $ from "jquery";
export default {
  name: "SpecialScreeningsSlider",

  components: {
    Slick
  },

  data() {
    return {
      showModal: false,
      movieSlider: {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      SpecialScreening: [],
      routeName: ""
    };
  },
  mounted() {
    this.routeName = window.location.pathname;

    // this.getNowShowingData();
  },
  methods: {
    getNowShowingData: function() {
      let payload = {
        Version: "1"
      };
      makeRequest("/GetShows/", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.SpecialScreening = res.data.shows[1].Movies;
            this.$refs.slick2.destroy();
            this.$nextTick(() => {
              this.$refs.slick2.create();
              this.$refs.slick2.goTo(1, true);
            });
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/SpecialScreeningsSlider.vue